"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStoreCode = void 0;

var _client = require("@apollo/client");

var _storeCode = require("./store-code.gql");

var useStoreCode = function useStoreCode() {
  var _useQuery = (0, _client.useQuery)(_storeCode.GET_STORE_CODE, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  }),
      data = _useQuery.data,
      loading = _useQuery.loading;

  return {
    data: data,
    loading: loading
  };
};

exports.useStoreCode = useStoreCode;